<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title>
        <v-btn :to="{ name: 'tickets.create' }" class="btn-add-with-text">
          ارسال تیکت جدید
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-row class="py-2" no-gutters>
        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-select
            v-model="tableProps.length"
            :items="[10, 25, 50, 100, 200, 400]"
            dense
            hide-details
            outlined
            @change="reloadTable()"
          />
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
          <v-text-field
            v-model="tableProps.search"
            append-icon="mdi-magnify"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="جستجو"
            outlined
            @keydown.enter="reloadTable()"
            @click:append="reloadTable()"
            @click:clear="clearTableFilters"
          />
        </v-col>
      </v-row>

      <data-table
        v-if="rerender"
        :columns="columns"
        :data="data"
        :translate="translate"
        class="p-2"
        orderDir="desc"
      >
        <!--                      @on-table-props-changed="reloadTable">-->
        <div slot="filters"></div>
      </data-table>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="600"
      transition="dialog-bottom-transition"
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="primary" dark>
            <div class="text-h3 text-center">{{ item.title }}</div>
          </v-toolbar>
          <v-card-text>
            <div class="text-h5 pt-5" v-html="item.text"></div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="pink" dark text @click="dialog.value = false"
              >بستن</v-btn
            >
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Button from "@/view/pages/Button";
import interActionBtn from "@/view/pages/tickets/interActionBtn";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";

export default {
  name: "ticketsIndex",
  data() {
    return {
      loading: false,
      data: {},
      dialog: false,
      rerender: true,
      item: null,
      url: "myTickets",
      columns: [
        {
          name: "show",
          label: "مشاهده چت",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "notification_",
            buttons: [
              {
                name: "show",
                label: "نمایش",
                icon: "comment",
                class: "btn-outline-info",
              },
            ],
          },
        },

        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
          orderable: true,
        },
        {
          label: "وضعیت",
          name: "status",
          orderable: true,
          transform: (value) => {
            return this.ticketStatus(value.data.status);
          },
        },

        {
          name: "updated_at",
          label: "آخرین به روزرسانی",
          orderable: true,
          transform: (value) => {
            return this.$options.filters.longDate(value.data.updated_at);
          },
        },

        {
          name: "actions",
          label: "بازخورد",
          component: interActionBtn,
          handler: this.actions,
          event: "action",
        },
      ],
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
    };
  },

  created() {
    this.getNotifications(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  methods: {
    reloadTable(tableProps) {
      this.getNotifications(this.url, tableProps);
    },
    getNotifications(url = this.url, query = this.tableProps) {
      this.loading = true;
      this.requestApiGet(url, query)
        .then((response) => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {});
    },
    reload() {
      this.getNotifications(this.url, this.tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    showListAgain(data) {
      this.$forceUpdate();
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
      });
      this.getNotifications(this.url);
    },
    show(data) {
      this.$router.push({ name: "tickets.edit", params: { id: data.id } });
    },
    edit(data) {
      this.$router.push({ name: "adminTickets.edit", params: { id: data.id } });
    },
    ticketStatus(data) {
      if (data === "open") {
        return "باز";
      } else if (data === "closed") {
        return "بسته";
      } else if (data === "notification") {
        return " اطلاع رسانی";
      } else if (data === "push_notification") {
        return "اطلاع رسانی درون برنامه ای";
      }
    },
    notifyStatus(data) {
      if (data.status === "pending") {
        return "در انتظار";
      } else if (data.status === "sent") {
        return "ارسال شده";
      } else if (data.status === "denied") {
        return "ارسال نشده";
      } else if (data.status === "payed") {
        return "پرداخت شده";
      } else if (data.status === "approved") {
        return "تایید شده";
      }
    },
    clearTableFilters() {
      this.$nextTick(() => {
        this.reloadTable();
      });
    },
  },
};
</script>
